import angular from 'angular';

import notificationModule from '../ui/notification/notification.module';
import { workingWith } from './working.with.directive';

export default angular
  .module('working.with', [notificationModule.name])
  .directive('workingWith', workingWith)
  .directive('estIndeterminate', () => ({
    restrict: 'A',
    link: (
      scope: angular.IScope,
      element: angular.IAugmentedJQuery,
      attrs: angular.IAttributes,
    ) => {
      scope.$watch(attrs['estIndeterminate'], (value: unknown) => {
        (element[0] as HTMLInputElement).indeterminate = !!value;
      });
    },
  }));
